import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="window-close"
export default class extends Controller {
  connect() {
    if (this.element.id === 'close') {
      this.windowClose()
    }
  }

  windowClose() {
    window.close();
  }
}
